import Information from 'components/contentBlocks/Information';
import PropTypes from 'prop-types';
import React from 'react';
import decodeHTMLEntities from '@nwg/core-web/utils/decodeHTMLEntities';
import transformButtons from 'libs/wordpress/utils/transformButtons';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

// Pure CMS data transformation before we send it to the "real" block!
const InformationTransformer = ({ content }) => {
    const { buttons, heading, paragraph, tag } = content;

    return (
        <Information
            buttons={buttons ? transformButtons(buttons, { theme: 'outlinedBlack' }) : null}
            heading={decodeHTMLEntities(heading?.text)}
            headingSize="lg"
            headingTag={heading?.type}
            tag={decodeHTMLEntities(tag)}
            text={paragraph}
        />
    );
};

InformationTransformer.propTypes = {
    content: PropTypes.shape({
        buttons: PropTypes.arrayOf(PropTypes.object),
        heading: PropTypes.object,
        paragraph: wysiwygProp,
        tag: PropTypes.string,
    }).isRequired,
};

export default InformationTransformer;
